import React, { useState, useRef, useEffect } from 'react';

function ReadMore({ content, charLimit = 150, readMoreText = 'Read more', readLessText = 'Read less', className, readMoreLessClass, showAsHTML, readMoreClickAction, contentInAction }) {
  const [isReadMore, setIsReadMore] = useState(true);
  const [trimmedText, setTrimmedText] = useState('');
  const [fullText, setFullText] = useState('');

  const textRef = useRef(null);

  useEffect(() => {
    setIsReadMore(true);
    if (textRef.current) {
      const textString = textRef.current.innerText;
      const trimmedString = textString.substr(0, charLimit);
      const finalString =
        textString.length <= charLimit
          ? trimmedString
          : trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(' ') < 0 ? trimmedString.length : trimmedString.lastIndexOf(' ')));
      setTrimmedText(finalString);
      setFullText(textString);
    }
  }, [textRef.current, content]);

  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };

  const clickAction = () => {
    if (contentInAction) {
      readMoreClickAction(contentInAction);
    } else {
      readMoreClickAction();
    }
  };

  return (
    <div className={className ? className : 'readMoreLessContainer'}>
      <div ref={textRef} dangerouslySetInnerHTML={{ __html: content }} style={isReadMore || !showAsHTML ? { display: 'none' } : {}} />
      {fullText && isReadMore ? trimmedText : showAsHTML ? '' : fullText}
      {fullText && fullText.length !== trimmedText.length ? (
        <span onClick={readMoreClickAction ? clickAction : toggleReadMore} className={readMoreLessClass ? readMoreLessClass : 'readMoreLessLink'}>
          {isReadMore ? `...${readMoreText}` : ` ${readLessText}`}
        </span>
      ) : null}
    </div>
  );
}

export default ReadMore;
